import React from 'react';
import PropTypes from 'prop-types';
import { Element } from '../elements/elements';
import toDangerousReactHtml from '../../helper/to_dangerous_react_html';
import Translation from '../translation/translation';

export const IconHeadlineTextCentered = props => {
    const realIconPath = props.prependStaticImagePath
        ? props.staticUrl + 'images/' + props.iconPath
        : props.iconPath;

    const tagName = props.link
        ? 'a'
        : 'div';

    const classNames = [
        'icon-headline-text-centered',
        ...props.additionalClassNames,
    ];

    const attributes = props.link
        ? { href: props.link }
        : {};

    return (
        <Element tagName={tagName} { ...attributes }>
            <div className="icon-headline-text-centered__icon icon-headline-text-centered-icon">
                <img
                    src={realIconPath}
                    alt={props.iconAltText}
                    className="icon-headline-text-centered-icon__image"
                />
            </div>

            <Translation
                tagName={props.headlineTag}
                className="icon-headline-text-centered__headline icon-headline-text-centered-headline"
                translationKey={props.headlineTranslationKey}
                placeholder={props.headlinePlaceholder}
            />

            {props.contentTranslationKey &&
                <Translation
                    tagName="div"
                    className="icon-headline-text-centered__content icon-headline-text-centered-content"
                    translationKey={props.contentTranslationKey}
                    placeholder={props.contentPlaceholder}
                />
            }
        </Element>
    );
};

IconHeadlineTextCentered.propTypes = {
    iconPath: PropTypes.string.isRequired,
    headlineTranslationKey: PropTypes.string.isRequired,
    staticUrl: PropTypes.string.isRequired,
    contentTranslationKey: PropTypes.string,
    contentPlaceholder: PropTypes.object,
    headlinePlaceholder: PropTypes.object,
    iconAltText: PropTypes.string,
    headlineTag: PropTypes.string,
    prependStaticImagePath: PropTypes.bool,
    additionalClassNames: PropTypes.arrayOf(PropTypes.string),
    text: PropTypes.string,
    link: PropTypes.string,
};

IconHeadlineTextCentered.defaultProps = {
    prependStaticImagePath: true,
    headlineTag: 'h4',
    iconAltText: '',
    link: '',
    text: '',
    headlinePlaceholder: {},
    additionalClassNames: [],
};
